import styled from 'styled-components';

import { ReceiptDetail as BaseReceiptDetail } from './receipt-details.styled.default';

export * from './receipt-details.styled.default';

export const ReceiptDetail = styled(BaseReceiptDetail)`
  p {
    font-size: 1rem;
  }
`;

export const RewardsDiscountDetail = ReceiptDetail;
